// ─── Dashboard filters onto a merged tile's other sources ────────────────────
// A Looker merged-results tile joins several queries (server/mergeResults.js).
// Its PRIMARY source is tile.query and takes the dashboard filters through
// tile.listenTo like any tile; every other source has its own wiring on
// tile.query.merge.sources[i].listenTo, because its fields live on a different
// explore. This applies the current value of each filter NAME to those sources.
// Mirrors withSourceFilters in server/mergeResults.js — keep the two in sync.
// The server still scopes every source; this only carries the filter values.
import { ANY_VALUE } from './filterConstants.js';

export function withMergeFilters(query, valueOf) {
  const sources = query && query.merge && query.merge.sources;
  if (!Array.isArray(sources) || !sources.length) return query;
  let changed = false;
  const next = sources.map((s) => {
    const filters = { ...((s.query && s.query.filters) || {}) };
    let mine = false;
    for (const [name, field] of Object.entries(s.listenTo || {})) {
      const v = valueOf(name);
      if (v == null || !String(v).trim()) continue;
      filters[field] = v === ANY_VALUE ? ANY_VALUE : String(v).trim();
      mine = true;
    }
    if (!mine) return s;
    changed = true;
    return { ...s, query: { ...s.query, filters } };
  });
  return changed ? { ...query, merge: { ...query.merge, sources: next } } : query;
}
